var _g, _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadFolder = function SvgDownloadFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220,
    height: 228,
    fill: "none",
    viewBox: "0 0 220 228"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint0_linear_1513_18696)",
    d: "m181.762 109.401-72.325-17.243v134.96l72.325-18.743z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint1_linear_1513_18696)",
    d: "m181.763 109.401-72.326-17.244v134.961l72.326-18.743z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint2_linear_1513_18696)",
    d: "m37.108 109.401 72.328-17.244v134.961l-72.328-18.371z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint3_linear_1513_18696)",
    d: "m37.108 109.401 72.328-17.244v134.961l-72.328-18.371z",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint4_linear_1513_18696)",
    d: "m109.437 92.157 37.487-30.74 72.326 18.37-37.488 29.614z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint5_linear_1513_18696)",
    d: "M0 80.16 37.108 109.4l72.329-17.244-36.732-30.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint6_linear_1513_18696)",
    d: "M0 80.16 37.108 109.4l72.329-17.244-36.732-30.74z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    width: 53.683,
    height: 49.037,
    x: 55.792,
    y: 76.558,
    fill: "url(#download-folder_svg__paint7_linear_1513_18696)",
    opacity: 0.5,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 52.447,
    height: 47.849,
    x: 56.446,
    y: 76.936,
    fill: "url(#download-folder_svg__paint8_linear_1513_18696)",
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.845,
    height: 7.881,
    x: 60.487,
    y: 84.817,
    fill: "url(#download-folder_svg__paint9_linear_1513_18696)",
    rx: 3.941
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.161,
    height: 0.875,
    x: 71.985,
    y: 84.817,
    fill: "url(#download-folder_svg__paint10_linear_1513_18696)",
    rx: 0.438
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.161,
    height: 0.875,
    x: 71.985,
    y: 87.444,
    fill: "url(#download-folder_svg__paint11_linear_1513_18696)",
    rx: 0.438
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.542,
    height: 0.875,
    x: 59.603,
    y: 96.981,
    fill: "url(#download-folder_svg__paint12_linear_1513_18696)",
    rx: 0.438
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.542,
    height: 0.875,
    x: 59.603,
    y: 99.607,
    fill: "url(#download-folder_svg__paint13_linear_1513_18696)",
    rx: 0.438
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.542,
    height: 0.875,
    x: 59.603,
    y: 103.108,
    fill: "url(#download-folder_svg__paint14_linear_1513_18696)",
    rx: 0.438
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.418,
    height: 0.875,
    x: 59.603,
    y: 105.737,
    fill: "url(#download-folder_svg__paint15_linear_1513_18696)",
    rx: 0.438
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.542,
    height: 0.875,
    x: 59.603,
    y: 109.23,
    fill: "url(#download-folder_svg__paint16_linear_1513_18696)",
    rx: 0.438
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.542,
    height: 0.875,
    x: 59.603,
    y: 111.856,
    fill: "url(#download-folder_svg__paint17_linear_1513_18696)",
    rx: 0.438
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.542,
    height: 0.875,
    x: 59.603,
    y: 115.36,
    fill: "url(#download-folder_svg__paint18_linear_1513_18696)",
    rx: 0.438
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.418,
    height: 0.875,
    x: 59.603,
    y: 117.986,
    fill: "url(#download-folder_svg__paint19_linear_1513_18696)",
    rx: 0.438
  }), /*#__PURE__*/React.createElement("rect", {
    width: 53.683,
    height: 49.037,
    x: 63.893,
    y: 87.887,
    fill: "url(#download-folder_svg__paint20_linear_1513_18696)",
    opacity: 0.5,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 52.447,
    height: 47.849,
    x: 64.547,
    y: 88.268,
    fill: "url(#download-folder_svg__paint21_linear_1513_18696)",
    rx: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.845,
    height: 7.881,
    x: 68.589,
    y: 96.15,
    fill: "url(#download-folder_svg__paint22_linear_1513_18696)",
    rx: 3.941
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.161,
    height: 0.875,
    x: 80.089,
    y: 96.15,
    fill: "url(#download-folder_svg__paint23_linear_1513_18696)",
    rx: 0.438
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.161,
    height: 0.875,
    x: 80.089,
    y: 98.776,
    fill: "url(#download-folder_svg__paint24_linear_1513_18696)",
    rx: 0.438
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.542,
    height: 0.875,
    x: 67.705,
    y: 108.31,
    fill: "url(#download-folder_svg__paint25_linear_1513_18696)",
    rx: 0.438
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.542,
    height: 0.875,
    x: 67.705,
    y: 110.939,
    fill: "url(#download-folder_svg__paint26_linear_1513_18696)",
    rx: 0.438
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.542,
    height: 0.875,
    x: 67.705,
    y: 114.44,
    fill: "url(#download-folder_svg__paint27_linear_1513_18696)",
    rx: 0.438
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.418,
    height: 0.875,
    x: 67.705,
    y: 117.066,
    fill: "url(#download-folder_svg__paint28_linear_1513_18696)",
    rx: 0.438
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.542,
    height: 0.875,
    x: 67.705,
    y: 120.562,
    fill: "url(#download-folder_svg__paint29_linear_1513_18696)",
    rx: 0.438
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.542,
    height: 0.875,
    x: 67.705,
    y: 123.188,
    fill: "url(#download-folder_svg__paint30_linear_1513_18696)",
    rx: 0.438
  }), /*#__PURE__*/React.createElement("rect", {
    width: 47.542,
    height: 0.875,
    x: 67.705,
    y: 126.692,
    fill: "url(#download-folder_svg__paint31_linear_1513_18696)",
    rx: 0.438
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.418,
    height: 0.875,
    x: 67.705,
    y: 129.318,
    fill: "url(#download-folder_svg__paint32_linear_1513_18696)",
    rx: 0.438
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint33_linear_1513_18696)",
    d: "M95.111 94.233h46.514v54.106H95.111z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint34_linear_1513_18696)",
    d: "M96.542 95.106h44.095v52.039H96.542z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint35_linear_1513_18696)",
    fillRule: "evenodd",
    d: "M120.991 102.073v1.307h3.363v6.421h-11.53v-6.421h3.373v-1.307zm-.613.47h-3.584v.831h3.584z",
    clipRule: "evenodd",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint36_linear_1513_18696)",
    d: "M113.311 103.596h10.556v5.879h-10.556z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint37_linear_1513_18696)",
    d: "M116.391 102.398v1.526h.549v-1.088h3.298v1.088h.55v-1.526z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint38_linear_1513_18696)",
    d: "M103.14 117.936h31.009v1.307H103.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint39_linear_1513_18696)",
    d: "M103.14 126.536h31.009v1.307H103.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint40_linear_1513_18696)",
    d: "M103.14 128.822h31.009v1.307H103.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint41_linear_1513_18696)",
    d: "M103.14 124.25h13.086v1.307H103.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint42_linear_1513_18696)",
    d: "M124.363 124.25h9.786v1.307h-9.786z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint43_linear_1513_18696)",
    d: "M114.025 134.156h9.786v1.307h-9.786z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint44_linear_1513_18696)",
    d: "M37.108 109.401v99.347l72.328 18.37v-98.595z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint45_linear_1513_18696)",
    d: "m181.762 208.375-72.325 18.743v-98.595l72.325-19.122z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint46_linear_1513_18696)",
    d: "m181.763 208.375-72.326 18.743v-98.595l72.326-19.122z",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint47_linear_1513_18696)",
    d: "M152.982 175.384v32.615l28.78-7.872v-32.616z",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint48_linear_1513_18696)",
    d: "M143.91 101.115h21.331v20.29H143.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint49_linear_1513_18696)",
    d: "M144.245 101.612h20.661v19.379h-20.661z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint50_linear_1513_18696)",
    fillRule: "evenodd",
    d: "M156.402 104.022v.987h2.559v4.892h-8.773v-4.886h2.56v-.993zm-.454.354h-2.742v.633h2.742z",
    clipRule: "evenodd",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint51_linear_1513_18696)",
    d: "M150.56 105.175h8.029v4.471h-8.029z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint52_linear_1513_18696)",
    d: "M152.901 104.261v1.162h.422v-.828h2.509v.828h.418v-1.162z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint53_linear_1513_18696)",
    d: "M151.02 113.124h7.444v.994h-7.444z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint54_linear_1513_18696)",
    d: "M148.217 114.946h12.716v.994h-12.716z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint55_linear_1513_18696)",
    d: "M93.342 39.092h27.636v22.475H93.342z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint56_linear_1513_18696)",
    d: "M93.665 39.518h26.94v21.677h-26.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint57_linear_1513_18696)",
    d: "M93.665 39.518h26.94v4.835h-26.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint58_linear_1513_18696)",
    d: "M93.665 39.518h26.94v4.835h-26.94z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint59_linear_1513_18696)",
    d: "M95.813 46.107h22.648v2.815H95.813z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint60_linear_1513_18696)",
    d: "M95.813 51.048h16.53v.955h-16.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint61_linear_1513_18696)",
    d: "M95.813 52.696h10.732v.955H95.813z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint62_linear_1513_18696)",
    d: "M95.813 54.343h14.168v.955H95.813z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint63_linear_1513_18696)",
    d: "M95.813 55.987h16.53v.955h-16.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint64_linear_1513_18696)",
    d: "M95.813 57.634h5.526v.955h-5.526z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint65_linear_1513_18696)",
    d: "M133.975 55.969h34.255v27.855h-34.255z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint66_linear_1513_18696)",
    d: "M134.376 56.496h33.392v26.867h-33.392z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint67_linear_1513_18696)",
    d: "M134.376 56.496h33.392v5.991h-33.392z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint68_linear_1513_18696)",
    d: "M137.034 64.66h28.069v3.49h-28.069z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint69_linear_1513_18696)",
    d: "M137.034 70.785h20.488v1.186h-20.488z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint70_linear_1513_18696)",
    d: "M137.034 72.825h13.304v1.186h-13.304z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint71_linear_1513_18696)",
    d: "M137.034 74.869h17.561v1.186h-17.561z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint72_linear_1513_18696)",
    d: "M137.034 76.909h20.488v1.186h-20.488z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint73_linear_1513_18696)",
    d: "M137.034 78.95h6.852v1.186h-6.852z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint74_linear_1513_18696)",
    d: "M138.498 65.846h7.981v1.053h-7.981z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint75_linear_1513_18696)",
    d: "m36.164 160.949 40.516 10.123 32.565-26.243v-16.12L36.92 110.714z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint76_linear_1513_18696)",
    d: "m182.33 160.949-40.52 10.123-32.564-26.243v-16.12l72.325-17.995z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint77_linear_1513_18696)",
    d: "M37.108 109.401 0 139.77l72.326 17.995 37.111-29.242z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint78_linear_1513_18696)",
    d: "m181.762 109.401 37.488 30.369-71.947 17.995-37.866-29.242z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint79_linear_1513_18696)",
    d: "m181.763 109.401 37.487 30.369-71.946 17.995-37.867-29.242z",
    opacity: 0.07
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#535461",
    d: "m180.978 109.743-71.793-17.01v133.115l71.793-18.487z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m180.978 109.743-71.793-17.01v133.115l71.793-18.487z",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#535461",
    d: "m38.888 109.743 71.793-17.01v133.116l-71.793-18.12z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m38.888 108.363 71.793-17.126v134.611l-71.793-18.242z",
    opacity: 0.17
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    d: "m109.185 90.699 38.182-30.872 72.499 18.099-38.182 29.763z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    d: "m2.992 79.434 36.518 28.255 71.171-16.664-36.144-29.702z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53.3,
    height: 50.668,
    x: 57.084,
    y: 74.858,
    fill: "url(#download-folder_svg__paint80_linear_1513_18696)",
    opacity: 0.5,
    rx: 4.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 52.349,
    height: 46.366,
    x: 58.331,
    y: 77.776,
    fill: "#F5F5F5",
    rx: 4.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 8.974,
    height: 8.974,
    x: 61.323,
    y: 83.758,
    fill: "#145ECC",
    rx: 4.487
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 34.401,
    height: 1.496,
    x: 73.289,
    y: 83.758,
    fill: "#E0E0E0",
    rx: 0.748
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 34.401,
    height: 1.496,
    x: 73.289,
    y: 85.254,
    fill: "#E0E0E0",
    rx: 0.748
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 47.862,
    height: 1.496,
    x: 59.828,
    y: 95.724,
    fill: "#E0E0E0",
    rx: 0.748
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 47.862,
    height: 1.496,
    x: 59.828,
    y: 98.716,
    fill: "#E0E0E0",
    rx: 0.748
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 47.862,
    height: 1.496,
    x: 59.828,
    y: 101.706,
    fill: "#E0E0E0",
    rx: 0.748
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 26.922,
    height: 1.496,
    x: 61.323,
    y: 103.202,
    fill: "#E0E0E0",
    rx: 0.748
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 47.862,
    height: 1.496,
    x: 59.828,
    y: 107.689,
    fill: "#E0E0E0",
    rx: 0.748
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 47.862,
    height: 1.496,
    x: 59.828,
    y: 110.681,
    fill: "#E0E0E0",
    rx: 0.748
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 47.862,
    height: 1.496,
    x: 59.828,
    y: 113.672,
    fill: "#E0E0E0",
    rx: 0.748
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 26.922,
    height: 1.496,
    x: 61.323,
    y: 115.168,
    fill: "#E0E0E0",
    rx: 0.748
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 53.598,
    height: 50.668,
    x: 64.531,
    y: 85.325,
    fill: "url(#download-folder_svg__paint81_linear_1513_18696)",
    opacity: 0.5,
    rx: 4.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 52.349,
    height: 46.366,
    x: 65.81,
    y: 86.75,
    fill: "#fff",
    rx: 4.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 8.974,
    height: 8.974,
    x: 70.297,
    y: 94.228,
    fill: "#145ECC",
    rx: 4.487
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 34.401,
    height: 1.496,
    x: 80.767,
    y: 95.724,
    fill: "#E0E0E0",
    rx: 0.748
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 34.401,
    height: 1.496,
    x: 80.767,
    y: 97.219,
    fill: "#E0E0E0",
    rx: 0.748
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 47.862,
    height: 1.496,
    x: 68.802,
    y: 107.689,
    fill: "#E0E0E0",
    rx: 0.748
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 47.862,
    height: 1.496,
    x: 68.802,
    y: 109.185,
    fill: "#E0E0E0",
    rx: 0.748
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 47.862,
    height: 1.496,
    x: 68.802,
    y: 113.672,
    fill: "#E0E0E0",
    rx: 0.748
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 26.922,
    height: 1.496,
    x: 70.297,
    y: 115.168,
    fill: "#E0E0E0",
    rx: 0.748
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 47.862,
    height: 1.496,
    x: 68.802,
    y: 118.159,
    fill: "#E0E0E0",
    rx: 0.748
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 47.862,
    height: 1.496,
    x: 68.802,
    y: 122.646,
    fill: "#E0E0E0",
    rx: 0.748
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 47.862,
    height: 1.496,
    x: 68.802,
    y: 125.637,
    fill: "#E0E0E0",
    rx: 0.748
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 26.922,
    height: 1.496,
    x: 70.297,
    y: 127.133,
    fill: "#E0E0E0",
    rx: 0.748
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint82_linear_1513_18696)",
    d: "M97.318 91.392h44.694v55.155H97.318z",
    opacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M98.715 92.732h43.375v52.349H98.715z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint83_linear_1513_18696)",
    fillRule: "evenodd",
    d: "M122.03 100.47v1.46h3.424v7.156h-11.742v-7.156h3.424v-1.46zm-.613.532h-3.682v.928h3.682z",
    clipRule: "evenodd",
    opacity: 0.5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#145ECC",
    d: "M115.167 103.202h10.47v4.487h-10.47zM116.664 100.211v1.495h.372v-1.068h2.244v1.068h.375v-1.495z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M103.202 115.168h31.409v1.496h-31.409zM103.202 125.637h31.409v1.496h-31.409zM103.202 127.133h31.409v1.496h-31.409zM103.202 122.646h13.461v1.496h-13.461z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#3AD29F",
    d: "M124.142 122.646h10.47v1.496h-10.47z",
    opacity: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#145ECC",
    d: "M115.167 131.62h10.47v1.496h-10.47z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    d: "M38.888 109.185v98.456l72.312 18.207.976-97.714z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    d: "m180.978 207.272-71.793 18.576v-97.714l71.793-18.949z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    d: "M152.56 172.38v32.529l28.418-7.851v-32.533z",
    opacity: 0.07
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint84_linear_1513_18696)",
    d: "M145.082 100.211h20.94v19.444h-20.94z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M145.082 100.211h19.444v19.444h-19.444z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint85_linear_1513_18696)",
    fillRule: "evenodd",
    d: "M157.281 103.259v.758h2.539v3.666h-8.708v-3.675h2.54v-.749zm-.452.282h-2.723v.476h2.723z",
    clipRule: "evenodd",
    opacity: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#145ECC",
    d: "M149.568 103.202h8.974v2.991h-8.974zM154.056 101.707v1.495h.374v-1.068h2.245v1.068h.372v-1.495zM149.882 112.427h8.529v.996h-8.529z",
    opacity: 0.6
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M148.073 113.672h13.461v1.496h-13.461z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint86_linear_1513_18696)",
    d: "M125.638 0h20.94v19.444h-20.94z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M125.638 0h19.444v19.444h-19.444z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint87_linear_1513_18696)",
    fillRule: "evenodd",
    d: "M136.38 3.146v.711h2.539v3.5h-8.708v-3.5h2.54v-.711zm-.453.258h-2.722v.453h2.722z",
    clipRule: "evenodd",
    opacity: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#145ECC",
    d: "M130.125 4.487h8.974v2.991h-8.974zM133.116 2.991v1.496h.374V3.418h2.245v1.069h.372V2.99zM131.634 12.063h8.87v1.245h-8.87z",
    opacity: 0.6
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M128.629 13.461h13.461v1.496h-13.461z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint88_linear_1513_18696)",
    d: "M94.364 37.581h26.555v22.243H94.364z",
    opacity: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M94.228 37.392h26.922v22.435H94.228z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#145ECC",
    d: "M94.228 38.888h26.922v4.487H94.228z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M94.228 38.888h26.922v4.487H94.228z",
    opacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M97.22 44.871h20.94v2.991H97.22zM97.22 47.862h16.453v1.496H97.22zM95.724 52.349h10.47v1.496h-10.47z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M97.22 52.349h14.957v1.496H97.22zM97.22 53.845h16.453v1.496H97.22z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M97.22 55.34h5.983v1.496H97.22z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#download-folder_svg__paint89_linear_1513_18696)",
    d: "M134.706 53.911h32.533v28.234h-32.533z",
    opacity: 0.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M134.612 55.34h32.905v26.922h-32.905z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#145ECC",
    d: "M134.612 55.34h32.905v4.487h-32.905z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M137.603 64.314h26.922v2.991h-26.922z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M137.603 70.297h19.444v1.496h-19.444zM137.603 71.793h13.461v1.496h-13.461z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M136.107 73.288h17.948v1.496h-17.948zM137.603 74.784h19.444v1.496h-19.444zM137.603 76.28h5.983v1.496h-5.983z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#69F0AE",
    d: "M137.603 62.819h8.974v1.496h-8.974z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m37.392 158.98 40.631 10.032L110.681 143v-15.978l-72.53-17.837z",
    opacity: 0.1
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m183.969 158.98-40.631 10.032L110.68 143v-15.978l72.53-17.837z",
    opacity: 0.1
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    d: "M38.014 107.689 1.496 137.741l71.17 17.81 36.519-28.939zM181.606 107.689l36.763 30.053-70.553 17.809-37.136-28.939z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint0_linear_1513_18696",
    x1: 109.437,
    x2: 181.762,
    y1: 227.12,
    y2: 227.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint1_linear_1513_18696",
    x1: 109.437,
    x2: 181.763,
    y1: 227.119,
    y2: 227.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint2_linear_1513_18696",
    x1: 37.108,
    x2: 109.436,
    y1: 227.119,
    y2: 227.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint3_linear_1513_18696",
    x1: 37.108,
    x2: 109.436,
    y1: 227.119,
    y2: 227.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint4_linear_1513_18696",
    x1: 109.437,
    x2: 219.25,
    y1: 109.401,
    y2: 109.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint5_linear_1513_18696",
    x1: 0,
    x2: 109.437,
    y1: 109.401,
    y2: 109.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint6_linear_1513_18696",
    x1: 0,
    x2: 109.437,
    y1: 109.401,
    y2: 109.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint7_linear_1513_18696",
    x1: 109.474,
    x2: 109.474,
    y1: 125.592,
    y2: 76.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint8_linear_1513_18696",
    x1: 56.446,
    x2: 108.892,
    y1: 124.785,
    y2: 124.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint9_linear_1513_18696",
    x1: 60.487,
    x2: 69.332,
    y1: 92.697,
    y2: 92.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint10_linear_1513_18696",
    x1: 71.985,
    x2: 107.145,
    y1: 85.693,
    y2: 85.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint11_linear_1513_18696",
    x1: 71.985,
    x2: 107.145,
    y1: 88.319,
    y2: 88.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint12_linear_1513_18696",
    x1: 59.603,
    x2: 107.145,
    y1: 97.856,
    y2: 97.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint13_linear_1513_18696",
    x1: 59.603,
    x2: 107.145,
    y1: 100.482,
    y2: 100.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint14_linear_1513_18696",
    x1: 59.603,
    x2: 107.145,
    y1: 103.984,
    y2: 103.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint15_linear_1513_18696",
    x1: 59.603,
    x2: 87.022,
    y1: 106.612,
    y2: 106.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint16_linear_1513_18696",
    x1: 59.603,
    x2: 107.145,
    y1: 110.105,
    y2: 110.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint17_linear_1513_18696",
    x1: 59.603,
    x2: 107.145,
    y1: 112.731,
    y2: 112.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint18_linear_1513_18696",
    x1: 59.603,
    x2: 107.145,
    y1: 116.235,
    y2: 116.235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint19_linear_1513_18696",
    x1: 59.603,
    x2: 87.022,
    y1: 118.861,
    y2: 118.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint20_linear_1513_18696",
    x1: 117.576,
    x2: 117.576,
    y1: 136.924,
    y2: 87.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint21_linear_1513_18696",
    x1: 64.547,
    x2: 116.994,
    y1: 136.117,
    y2: 136.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint22_linear_1513_18696",
    x1: 68.589,
    x2: 77.433,
    y1: 104.029,
    y2: 104.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint23_linear_1513_18696",
    x1: 80.089,
    x2: 115.25,
    y1: 97.025,
    y2: 97.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint24_linear_1513_18696",
    x1: 80.089,
    x2: 115.25,
    y1: 99.651,
    y2: 99.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint25_linear_1513_18696",
    x1: 67.705,
    x2: 115.25,
    y1: 109.185,
    y2: 109.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint26_linear_1513_18696",
    x1: 67.705,
    x2: 115.25,
    y1: 111.814,
    y2: 111.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint27_linear_1513_18696",
    x1: 67.705,
    x2: 115.25,
    y1: 115.316,
    y2: 115.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint28_linear_1513_18696",
    x1: 67.705,
    x2: 95.123,
    y1: 117.942,
    y2: 117.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint29_linear_1513_18696",
    x1: 67.705,
    x2: 115.25,
    y1: 121.437,
    y2: 121.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint30_linear_1513_18696",
    x1: 67.705,
    x2: 115.25,
    y1: 124.063,
    y2: 124.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint31_linear_1513_18696",
    x1: 67.705,
    x2: 115.25,
    y1: 127.568,
    y2: 127.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint32_linear_1513_18696",
    x1: 67.705,
    x2: 95.123,
    y1: 130.194,
    y2: 130.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint33_linear_1513_18696",
    x1: 141.625,
    x2: 141.625,
    y1: 148.339,
    y2: 94.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint34_linear_1513_18696",
    x1: 96.542,
    x2: 140.637,
    y1: 147.143,
    y2: 147.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint35_linear_1513_18696",
    x1: 124.354,
    x2: 124.354,
    y1: 109.801,
    y2: 102.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint36_linear_1513_18696",
    x1: 113.311,
    x2: 123.867,
    y1: 109.475,
    y2: 109.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint37_linear_1513_18696",
    x1: 116.391,
    x2: 120.788,
    y1: 103.924,
    y2: 103.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint38_linear_1513_18696",
    x1: 103.14,
    x2: 134.149,
    y1: 119.243,
    y2: 119.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint39_linear_1513_18696",
    x1: 103.14,
    x2: 134.149,
    y1: 127.843,
    y2: 127.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint40_linear_1513_18696",
    x1: 103.14,
    x2: 134.149,
    y1: 130.129,
    y2: 130.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint41_linear_1513_18696",
    x1: 103.14,
    x2: 116.226,
    y1: 125.557,
    y2: 125.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint42_linear_1513_18696",
    x1: 124.363,
    x2: 134.149,
    y1: 125.557,
    y2: 125.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint43_linear_1513_18696",
    x1: 114.025,
    x2: 123.813,
    y1: 135.464,
    y2: 135.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint44_linear_1513_18696",
    x1: 37.108,
    x2: 109.436,
    y1: 227.118,
    y2: 227.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint45_linear_1513_18696",
    x1: 109.437,
    x2: 181.762,
    y1: 227.118,
    y2: 227.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint46_linear_1513_18696",
    x1: 109.437,
    x2: 181.763,
    y1: 227.118,
    y2: 227.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint47_linear_1513_18696",
    x1: 152.982,
    x2: 181.762,
    y1: 207.998,
    y2: 207.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint48_linear_1513_18696",
    x1: 165.242,
    x2: 165.242,
    y1: 121.405,
    y2: 101.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint49_linear_1513_18696",
    x1: 144.245,
    x2: 164.907,
    y1: 120.992,
    y2: 120.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint50_linear_1513_18696",
    x1: 158.965,
    x2: 158.965,
    y1: 109.895,
    y2: 104.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint51_linear_1513_18696",
    x1: 150.56,
    x2: 158.592,
    y1: 109.647,
    y2: 109.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint52_linear_1513_18696",
    x1: 152.904,
    x2: 156.25,
    y1: 105.424,
    y2: 105.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint53_linear_1513_18696",
    x1: 151.02,
    x2: 158.466,
    y1: 114.118,
    y2: 114.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint54_linear_1513_18696",
    x1: 148.217,
    x2: 160.933,
    y1: 115.939,
    y2: 115.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint55_linear_1513_18696",
    x1: 120.981,
    x2: 120.981,
    y1: 61.567,
    y2: 39.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint56_linear_1513_18696",
    x1: 93.665,
    x2: 120.605,
    y1: 61.195,
    y2: 61.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint57_linear_1513_18696",
    x1: 93.665,
    x2: 120.605,
    y1: 44.352,
    y2: 44.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint58_linear_1513_18696",
    x1: 93.665,
    x2: 120.605,
    y1: 44.352,
    y2: 44.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint59_linear_1513_18696",
    x1: 95.813,
    x2: 118.458,
    y1: 48.922,
    y2: 48.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint60_linear_1513_18696",
    x1: 95.813,
    x2: 112.34,
    y1: 52.002,
    y2: 52.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint61_linear_1513_18696",
    x1: 95.813,
    x2: 106.545,
    y1: 53.649,
    y2: 53.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint62_linear_1513_18696",
    x1: 95.813,
    x2: 109.981,
    y1: 55.296,
    y2: 55.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint63_linear_1513_18696",
    x1: 95.813,
    x2: 112.34,
    y1: 56.944,
    y2: 56.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint64_linear_1513_18696",
    x1: 95.813,
    x2: 101.339,
    y1: 58.591,
    y2: 58.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint65_linear_1513_18696",
    x1: 168.231,
    x2: 168.231,
    y1: 83.824,
    y2: 55.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint66_linear_1513_18696",
    x1: 134.376,
    x2: 167.765,
    y1: 83.36,
    y2: 83.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint67_linear_1513_18696",
    x1: 134.376,
    x2: 167.765,
    y1: 62.487,
    y2: 62.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint68_linear_1513_18696",
    x1: 137.034,
    x2: 165.104,
    y1: 68.15,
    y2: 68.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint69_linear_1513_18696",
    x1: 137.034,
    x2: 157.522,
    y1: 71.969,
    y2: 71.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint70_linear_1513_18696",
    x1: 137.034,
    x2: 150.339,
    y1: 74.013,
    y2: 74.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint71_linear_1513_18696",
    x1: 137.034,
    x2: 154.595,
    y1: 76.053,
    y2: 76.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint72_linear_1513_18696",
    x1: 137.034,
    x2: 157.522,
    y1: 78.094,
    y2: 78.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint73_linear_1513_18696",
    x1: 137.034,
    x2: 143.886,
    y1: 80.137,
    y2: 80.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint74_linear_1513_18696",
    x1: 138.498,
    x2: 146.479,
    y1: 66.899,
    y2: 66.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint75_linear_1513_18696",
    x1: 36.164,
    x2: 109.245,
    y1: 171.072,
    y2: 171.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint76_linear_1513_18696",
    x1: 109.246,
    x2: 182.33,
    y1: 171.072,
    y2: 171.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint77_linear_1513_18696",
    x1: 0,
    x2: 109.437,
    y1: 157.765,
    y2: 157.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint78_linear_1513_18696",
    x1: 109.437,
    x2: 219.25,
    y1: 157.765,
    y2: 157.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint79_linear_1513_18696",
    x1: 109.437,
    x2: 219.25,
    y1: 157.765,
    y2: 157.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint80_linear_1513_18696",
    x1: 110.385,
    x2: 110.385,
    y1: 125.526,
    y2: 74.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint81_linear_1513_18696",
    x1: 118.132,
    x2: 118.132,
    y1: 135.993,
    y2: 85.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint82_linear_1513_18696",
    x1: 142.014,
    x2: 142.014,
    y1: 146.546,
    y2: 91.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint83_linear_1513_18696",
    x1: 125.455,
    x2: 125.455,
    y1: 109.086,
    y2: 100.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint84_linear_1513_18696",
    x1: 166.021,
    x2: 166.021,
    y1: 119.655,
    y2: 100.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint85_linear_1513_18696",
    x1: 159.816,
    x2: 159.816,
    y1: 107.692,
    y2: 103.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint86_linear_1513_18696",
    x1: 146.577,
    x2: 146.577,
    y1: 19.444,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint87_linear_1513_18696",
    x1: 138.918,
    x2: 138.918,
    y1: 7.357,
    y2: 3.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint88_linear_1513_18696",
    x1: 120.92,
    x2: 120.92,
    y1: 59.824,
    y2: 37.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "download-folder_svg__paint89_linear_1513_18696",
    x1: 167.239,
    x2: 167.239,
    y1: 82.145,
    y2: 53.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))));
};
export default SvgDownloadFolder;